export default __webpack_public_path__ + "static/media/10F637C3-4DE4-4A4B-A13E-2FF1E720BDB1.3390defb.JPG";